import Image from "components/Image";
import type { ReactStoryblokComponent } from "modules/storyblok/types";
import type { ImageAdapterProps } from "./Image.d";

const ImageAdapter = ({
  blok: { src: srcDesktop, srcMobile, alt, height, link, content, credit },
}: ReactStoryblokComponent<ImageAdapterProps>) => (
  <Image
    srcDesktop={srcDesktop}
    srcMobile={srcMobile}
    alt={alt}
    height={height || "initial"}
    link={link?.url}
    content={content}
    credit={credit}
  />
);
export default ImageAdapter;
